import React from 'react';
import ReactPlayer from 'react-player';
import {SizeMe} from 'react-sizeme';

type Props = {
  contentURL: string;
};

export default function POCToolVideoContent(props: Props) {
  const {contentURL} = props;
  return (
    <SizeMe>
      {({size}) => (
        <ReactPlayer
          url={contentURL}
          playing={false}
          controls={true}
          width="100%"
          height={size.width ? (size.width / 16) * 9 : 1}
          style={styles.videoContainer as React.CSSProperties}
        />
      )}
    </SizeMe>
  );
}

const styles = {
  videoContainer: {
    objectFit: 'contain',
    marginTop: 25,
  },
};
